export default {
  login: {
    validation: {
      username: {
        required: 'Username is required',
      },
      password: {
        required: 'Password is required',
      },
    },
    notACustomer: 'Not a Webeo customer yet?',
    getInTouch:
      'Get in touch to arrange a demo and learn more about working with Webeo',
    loginForm: 'Login',
    loginButton: 'Log In',
    learnMore: 'Learn More',
    mfaDescPhrase1: 'Email has been sent.',
    mfaDescPhrase2: 'Please check your inbox for the verification code.',
    otpInvalidOrExpired: 'Your verification code is invalid or has expired.',
    otpDefaultIssuePhrase: 'Request was unsucessful. Please try again later.',
    otpNotArrived: 'Didn’t get code?',
    missingOtpReturnToLogin: 'If your code didn’t arrive, please click here.',
  },
  forgottenPassword: {
    submit: 'Submit',
    returnToLogin: 'Return to Login',
    validation: {
      username: {
        required: 'Username is required',
      },
    },
    confirmation: `An email has been sent to the address of the account.
    If you have not received a message, please check the spam folder.`,
  },
  support: {
    title: 'Support',
    unsure: 'Unsure? We can help you:',
  },
  selectClient: {
    continueButton: 'Continue',
    logoutButton: 'Log Out',
    description:
      'By selecting a client and continuing you will be logged in and be able to take actions for the chosen client.',
  },
  sideNav: {
    supportRequest: 'Support Request',
    feedback: 'Feedback',
    impersonation: {
      impersonating: 'Impersonating',
      switch: 'Switch',
    },
    userManagement: 'User Management',
    profile: 'Profile',
    logout: 'Log out',
  },
  resetPassword: {
    description:
      'Change your password. Use a strong password that you\'re not using elsewhere.',
    newPassword: {
      label: 'New password',
      info:
        `Enter your new password. This needs to meet the complexity requirements measured by the bar under the input. 
It also cannot contain your username`,
      placeHolder: 'New Password',
      requiredValidation: 'New password is required',
      complexityValidation: 'Password is not strong enough',
      minLengthValidation: 'Password is not long enough. The required minimal length is ',
      maxLengthValidation: 'Password is too long. The maximum length is 50',
      helpPoint1: 'The new password must not contain your username',
      helpPoint2:
        `The password must meet certain complexity requirements. Longer passwords are preferred with a mixture of 
uppercase and lowercase letters, digits and symbols`,
      helpPoint3:
        'Your password is strong enough when the strength meter below has at least 3 bars filled',
    },
    confirmPassword: {
      label: 'Confirm new password',
      info: 'Enter your new password again to ensure you entered it correctly',
      placeHolder: 'Confirm Password',
      requiredValidation: 'Confirm password is required',
      matchValidation: 'Passwords do not match',
    },
    returnToLogin: 'Return to Login',
    updateButton: 'Reset Password',
    updateSuccessMessage:
      'Password has been successfully reset, return to Login',
    updateErrorMessage:
      'An error has occurred, please try again or contact Webeo Support',
  },
  tutorialPopup: {
    title: 'Get Started with Webeo',
    createCampaignTile: {
      title: 'Create a Campaign',
      text:
        `Campaigns are a framework for organising audiences you want to target, and what personalised experiences 
they see`,
    },
    exploreTile: {
      title: 'Explore Webeo',
      text: 'Take a quick tour of some of the key features within Webeo!',
    },
    skipLink: 'Skip to dashboard',
  },
};
